/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Speed_Auto_TitleInputs */



/**
* | output |
* | --- |
* | "Auto-calculated speed" |
*
* @param {Audio_Recorder_Speed_Auto_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_speed_auto_title = /** @type {((inputs?: Audio_Recorder_Speed_Auto_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Speed_Auto_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vitesse calculée automatiquement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatisch berechnete Geschwindigkeit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Velocità calcolata automaticamente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматически рассчитываемая скорость")
	if (locale === "es") return /** @type {LocalizedString} */ ("Velocidad calculada automáticamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动计算速度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動計算された速度")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वतः गणना की गई गति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Velocidade calculada automaticamente")
	return /** @type {LocalizedString} */ ("Auto-calculated speed")
});